import BreadCrumbs from "../../components/BreadCrumbs";
import * as React from "react";
import {useContext, useEffect, useRef, useState} from "react";
import AuthContext from "../../context/AuthContext";
import {useParams} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Item from '@mui/material/Stack'
import Footer from "../../components/Footer";
import ImgComp from "../_subcomponents/ImgComp";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';
import ErrorIcon from '@mui/icons-material/Error';
import {LightTooltip} from "../_subcomponents/MapToolsBase";


export default function ProdDetails() {

    // Blocks: identifiers; images; descriptions; documents; videos; specs
    let {user, logoutUser, authTokens, serverIP, userPermissions} = useContext(AuthContext)

    const {prod_id} = useParams()

    const crumbItems = [
        {'name': 'Main', 'link': '/'},
        {'name': 'Mapper Projects', 'link': '../../../projects/1'},
        {'name': 'Products List', 'link': '../1'},
        {'name': 'Product details', 'link': ''}
    ]

    const [prodObj, setProdObj] = useState<any>({})
    // console.log(prodObj)

    useEffect(() => {
        getProdDetails()
    }, [])

    let getProdDetails = async () => {
        let response = await fetch(`${serverIP}/getproddetails/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify({prodID: prod_id}),
        })
        let data = await response.json()

        if (response.status === 200) {
            setProdObj(data)

        } else if (response.statusText === 'Unauthorized') {
            logoutUser()
        }
    }

    let uniqLocales: any[] = []
    try {
        uniqLocales = prodObj.uniqLocales.map((item: string, index: number) => {
            return <option key={index} value={item}>{item}</option>
        })
    } catch (err) {}

    // Descriptions processing
    const composeDescr = (loc: string) => {
        let out: any[] = []
        try {
            let textObj = prodObj['descriptions'][loc]
            for (let k in textObj) {
                out.push(
                    <div key={k} className="descr-element">
                        <div><b>{k}:</b></div>
                        <div>{textObj[k]}</div>
                    </div>)
            }
        } catch (err) {}
        return out
    }

    // RTBs
    const OneRTBComp = (props: any) => {
        const {rtbDataSet} = props

        return (
        <div className="one-rtb-container">
            <div className="one-rtb-image">
                <ImgComp src={rtbDataSet[2]} width="100px" height="100px" loading="lazy" />
            </div>
            <div className="one-rtb-text">
                <div><b>{rtbDataSet[0]}</b></div>
                <div>{rtbDataSet[1]}</div>
            </div>
        </div>
        )
    }

    function composeRTBs(loc: string) {
        let out: any[] = []

        try {
            out = prodObj['rtbs'][loc].map((item: any[], index: number) => {
                return <OneRTBComp key={index} rtbDataSet={item}/>
            })
        } catch (err) {}

        return out
    }

    // IMAGES
    const composeImages = (loc: string) => {
        let out: any[] = []

        try {
            out = prodObj['images'][loc].map((item: any, index: number) => {    // REMOVE SLICE AFTER CASHING RESOLVED //
                return <Item key={index}>
                    <ImgComp src={item[0]} width={100} height={100} loading="lazy" />
                </Item>
            })
        } catch (err) {}
        // console.log(out)
        return out
    }

    // MMOs
    const composeMMOs = (loc: string) => {
        let out: any[] = []

        for (let mmoType in prodObj['mediaObjects']) {
            if (loc in prodObj['mediaObjects'][mmoType]) {
                if (prodObj['mediaObjects'][mmoType][loc] instanceof Array) {

                    let innerElems: any[] = []

                    for (let item of prodObj['mediaObjects'][mmoType][loc]) {
                        innerElems.push(
                        <div key={item["name"].toLowerCase()} className="mmo-data">
                            <div>{item["URL"]}</div>
                            <div>{item["name"]}</div>
                            <div>{item["expiryDate"] || ''}</div>
                        </div>
                        )
                    }
                    //
                    out.push(
                        <div key={mmoType.toLowerCase()} className="mmotype-subcontainer">
                            <div className="mmo-label">{mmoType}</div>
                            <div>{innerElems}</div>
                        </div>
                    )

                } else if (prodObj['mediaObjects'][mmoType][loc] instanceof Object) {
                    let mmoObj = prodObj['mediaObjects'][mmoType][loc]
                    out.push(
                        <div key={mmoType.toLowerCase()} className="mmotype-subcontainer">
                            <div className="mmo-label">{mmoType}</div>
                            <div>
                                <div key={`${loc}_${mmoType}`} className="mmo-data">
                                    <div>{mmoObj["URL"]}</div>
                                    <div>{mmoObj["expiryDate"] || ''}</div>
                                </div>
                            </div>
                        </div>
                    )
                }
            }
        }
        return out
    }
    // const getUniqLocsMMO = () => {
    //     let pre = []
    //
    //     for (let k in prodObj['mediaObjects']) {
    //         let sub = Object.keys(prodObj['mediaObjects'][k])
    //         pre.push(...sub)
    //     }
    //     let out: any = Array.from(new Set(pre))    !! UNIQUE VALUES OF ARRAY
    //     return (out)
    // }

    // LifeCycles
    const composeLifeCycle = (loc: string) => {
        let out: any[] = []
         for (let k in prodObj['productLifeCycle']) {
             if (loc in prodObj['productLifeCycle'][k]) {
                 out.push(
                     <div key={k.toLowerCase()} className="lifecycle-subcontainer">
                         <div><b>{k}:</b></div>
                         <div>{prodObj['productLifeCycle'][k][loc]}</div>
                     </div>
                 )
             }
         }
        return out
    }

    // Local Specs object to nice-looking HTML elem
    const mergeLocalValues = (specObj: any) => {
        let out: any[] = []
        for (const k in specObj) {
            out.push(
                <div key={k.toLowerCase()} className="lifecycle-subcontainer">
                    <div>{k}:</div>
                    <div>{specObj[k]}</div>
                </div>
            )
        }
        return out
    }

    const composeFeedSpecs = () => {
        let out: any = undefined
        out = prodObj['feedSpecs'].map((item: any, index: number) => {
            let origVal = item[1]
            let finVal: any = ''
            if (typeof origVal === 'object') {
                finVal = mergeLocalValues(origVal)
            } else {
                finVal = origVal.toString().trim()
            }

            return (
                <div key={index} className="spec-row">
                    <div className="spec-label">{item[0]}</div>
                    <div style={{paddingRight: "5px"}}>{finVal}</div>
                </div>
            )
        })
        return out
    }

    const iceSpecStatus =(f_status:string, error_text: string) => {
        if (f_status == 'imported') {
            return <LightTooltip title="successfully exported into Icecat">
                <CheckCircleIcon sx={{color: "green", fontSize: "1.05rem"}}/>
            </LightTooltip>
        }
        if (f_status == 'new') {
            return <LightTooltip title="new or not yet imported">
                <PendingIcon sx={{ color: "grey", fontSize: "1.05rem"}}/>
            </LightTooltip>
        }
        if (f_status == 'error') {
            let toolTipText = `not imported. reason: "${error_text}"`
            return <LightTooltip title={toolTipText}>
                <ErrorIcon sx={{ color: "red", fontSize: "1.08rem"}} />
            </LightTooltip>
        }
        return <div></div>
    }


    const composeIceSpecs = () => {
        let out: any = undefined
        out = prodObj['iceSpecs'].map((item: any, index: number) => {
            let impStatus = item[3]
            let statusErrorText = ''
            if (impStatus !== 'imported' && impStatus !== 'new') {
                impStatus = 'error'
                statusErrorText = item[3]
            }
            console.log(impStatus)
            let impStatusIcon = iceSpecStatus(impStatus, statusErrorText)

            let origVal = item[2]
            let finVal: any = ''
            if (typeof origVal === 'object') {
                finVal = mergeLocalValues(origVal)
            } else {
                finVal = origVal.toString().trim()
            }

            return (
                <div key={index} className="spec-row-ice">
                    <div className="spec-label">{item[1]} (ID:{item[0]})</div>
                    <div style={{paddingRight: "5px"}}>{finVal}</div>
                    <div>{impStatusIcon}</div>
                </div>
            )
        })
        return out
    }


    // DATA SETTER
    const [activeName, setActiveName] = useState<string>('')
    const [activeText, setActiveText] = useState<any[]>([])
    const [activeBullets, setActiveBullets] = useState<any>('')
    const [activeRTBs, setActiveRTBs] = useState<any[]>([])
    const [activeImages, setActiveImages] = useState<any[]>([])
    const [activeMMOs, setActiveMMOs] = useState<any[]>([])
    const [activeLifeCycle, setActiveLifeCycle] = useState<any>([])
    const feedSpecsRef = useRef<any[]>([])
    const iceSpecsRef = useRef<any[]>([])


    function handleLocSelected(selectedLoc: string) {
        // console.log(selectedLoc)
        setActiveName(prodObj.hasOwnProperty('names') ?  prodObj['names'][selectedLoc] : '')
        setActiveBullets(prodObj.hasOwnProperty('bulletPoints') ?  prodObj['bulletPoints'][selectedLoc] : '')
        setActiveText(composeDescr(selectedLoc))
        setActiveRTBs(composeRTBs(selectedLoc))
        setActiveImages(composeImages(selectedLoc))
        setActiveMMOs(composeMMOs(selectedLoc))
        setActiveLifeCycle(composeLifeCycle(selectedLoc))
    }

    // PRE-SETTING DATA ON FIRST LOAD
    useEffect(() => {
        if (prodObj) {
            try {
                let onLoadLoc = prodObj?.uniqLocales[0]
                handleLocSelected(onLoadLoc)
            } catch (err) {}

            // processing original (feed) specs
            if ('feedSpecs' in prodObj) {
                feedSpecsRef.current = composeFeedSpecs()
            }

            // processing mapped (icecat) specs
            if ('iceSpecs' in prodObj) {
                iceSpecsRef.current = composeIceSpecs()
            }
        }
    }, [prodObj])


    return (
        <>
            <BreadCrumbs user={user} itemsLinks={crumbItems}/>

            <div className="product-detail-container">

                {/*  IDENTIFIERS  */}
                <div className="section-header">Identifiers</div>
                <div className="product-detail-identifiers">
                    <div>Feed ID:</div>
                    <div>{prodObj?.meta?.feedID || ''}</div>
                    <div>Status:</div>
                    <div>{prodObj?.meta?.status || ''}</div>
                    <div>Last updated:</div>
                    <div>{prodObj?.meta?.lastUpdate || ''}</div>
                    <div>Brand:</div>
                    <div>{prodObj?.brand?.name || ''}</div>
                    <div>MPN:</div>
                    <div>{prodObj?.mpn || ''}</div>
                    <div>Family:</div>
                    <div>{prodObj?.family?.name || ''}</div>
                    <div>Category ID:</div>
                    <div>{prodObj?.category?.ID || ''}</div>
                    <div>Category:</div>
                    <div className="items-merged">{prodObj?.category?.name || ''}</div>
                    {/*<div>Price:</div>*/}
                    {/*<div>{prodObj?.pricing?.MSRP || ''}</div>*/}
                    <div>Locales:</div>
                    <div>{prodObj?.uniqLocales?.length || ''}</div>
                    <div>EANs:</div>
                    <div className="items-merged">{prodObj?.eans?.join(', ') || ''}</div>
                </div>


                <div className="locales-container">
                    <div className="loc-label">Select locale:</div>
                    <select onChange={(event) => handleLocSelected(event.target.value)}>{uniqLocales}</select>
                </div>


                {/*  LIFECYCLE  */}
                {activeLifeCycle.length > 0 && <>
                    <div className="section-header">Dates</div>
                    <div className="asset-container">
                        <Paper className="lifecycle-container">{activeLifeCycle}</Paper>
                    </div>
                </>
                }

                {/*  NAMES  */}
                {activeName && <>
                    <div className="section-header">Name</div>
                    <div className="asset-container">
                        <Paper className="name-container">{activeName}</Paper>
                    </div>
                </>
                }

                {/*  DESCRIPTIONS  */}
                {activeText.length > 0 && <>
                    <div className="section-header">Description</div>
                    <div className="asset-container">
                        <Paper className="description-container">{activeText}</Paper>
                    </div>
                </>
                }

                {/*  BULLET POINTS  */}
                {activeBullets && <>
                    <div className="section-header">Bullet Points</div>
                    <div className="asset-container">
                        <Paper className="bullets-container">{activeBullets}</Paper>
                    </div>
                </>
                }

                {/*  RTBs  */}
                {activeRTBs.length > 0 && <>
                    <div className="section-header">Reasons-To-Buy (RTBs)</div>
                    <div className="asset-container">
                        <Paper className="rtbs-container">{activeRTBs}</Paper>
                    </div>
                </>
                }

                {/*  IMAGES   */}
                {activeImages.length >0 && <>
                    <div className="section-header">Images</div>
                    <div className="asset-container">
                        <Paper className="images-container">
                            <Stack direction="row" spacing={3}>
                                {activeImages}
                            </Stack>
                        </Paper>
                    </div>
                </>
                }

                {/*  MMOs -- DOCUMENTS & VIDEOS   */}
                {activeMMOs.length > 0 && <>
                    <div className="section-header">Documents & Videos</div>
                    <div className="asset-container">
                        <Paper className="mmos-container">{activeMMOs}</Paper>
                    </div>
                </>
                }


                {/*  SPECIFICATIONS   */}
                {feedSpecsRef.current.length > 0 && <>
                    <div className="section-header">Specifications</div>
                    <div className="asset-container">
                        <Paper  className="map-note-remark">
                        <strong>Important note!</strong> Specs are not transformed as 1-to-1. A set of input (source) specs is transformed into a set of output (target) specs.
                            For example, the same attribute might be a part of different transformation rules.
                        </Paper>

                        <div className="specs-container">

                            {/* original (feed) specs */}
                            <Paper className="specs-block">
                                <div className="spec-table-header">Original (feed) specs</div>
                                {feedSpecsRef.current}
                            </Paper>

                            {/* mapped (icecat) specs */}
                            <Paper className="specs-block bg-grey-icespecs">
                                <div className="spec-table-header">Mapped (icecat) specs</div>
                                {iceSpecsRef.current}
                            </Paper>

                        </div>

                    </div>
                </>
                }



            </div>    {/*  "product-detail-container"  */}

            <Footer/>
        </>
    )
}